import React, { useState,useContext,useEffect } from 'react'
import {dataContext,toText,localestr,load} from '../utils.js'
import UniTable from '../cmp/UniTable'
import FilterForm from '../cmp/FilterForm' //+
import Menu from '../cmp/menu'
import icon from '../icons.svg'
//import MsgForm from '../cmp/msgForm.js'

function IrgStopList({data=undefined,actions,choice=false}){
    const type='irgStopList'
    let wndData=''
    if(data) wndData=data.wndData
    else wndData=actions.getWndData()
    const setWndData=actions.setWndData
    //const tabNew=actions.tabNew
    const tabClose=actions.tabClose
    const tabChoice=actions.tabChoice
    const isActive=actions.isActive

    const context=useContext(dataContext)
    const Data=context.data[type]
    const getData=context.getData
    const saveData=context.saveData
    const updateData=context.updateData
    const addTWnd=context.addTWnd
    const msg=context.msg
    const inputNumber=context.inputNumber
    const inputCols=context.inputCols
    const setSettings=context.setSettings
    const getSettings=context.getSettings
    const usersettings=getSettings()

    let hiden=true
    if(wndData.hiden!==undefined) hiden=wndData.hiden
    const setHiden=d=>setWndData({...wndData,hiden:d})

    const [edit, setEdit] = useState(false)
    const [isActive2, setisActive] = useState(false)

    const cols=[
        {caption:'icon',minWidth:'20',dataId:'b958',sortable:false},
        //{caption:'id',minWidth:'12',dataId:'id',sortable:true},
        {caption:localestr('Товар'),minWidth:'140',dataId:'good',sortable:true},
        //{caption:localestr('Кількість'),minWidth:'160',dataId:'qtt',sortable:true,typeVal:'date',setFn:(d)=>{setVal('qtt',d)}},
        {caption:localestr('Кількість'),minWidth:'40',maxWidth:'50',dataId:'qtt',sortable:true},
        {caption:localestr('Внесено'),minWidth:'160',maxWidth:'170',dataId:'start',align:'center',sortable:true},
        //{caption:localestr('Відпрацьовано'),minWidth:'160',dataId:'worked',sortable:true,typeVal:'submit',setFn:()=>{saveValue()}},
        {caption:localestr('Автор'),minWidth:'140',dataId:'author',sortable:true},
    ]
    if(!hiden) cols.push({caption:localestr('Вилучено'),minWidth:'160',maxWidth:'170',dataId:'stop',align:'center',sortable:true})

    if(usersettings.CatDepartmentsList&&usersettings.CatDepartmentsList.cols){
        for(let i=0;i<usersettings.CatDepartmentsList.cols.length;i++){
            const idx=cols.findIndex(el=>el.dataId===usersettings.CatDepartmentsList.cols[i])
            if(idx!==-1) cols[idx].hiden=true
        }
    }

    const filterData=[ //+
        {caption:localestr('Товар'),dataId:'good',typeVal:'catGoods'},
        {caption:localestr('Початок'),dataId:'start',typeVal:'text'},
        {caption:localestr('Закінчення'),dataId:'finish',typeVal:'text'},
        {caption:localestr('Автор'),dataId:'author',typeVal:'catUsers'},
        //{caption:localestr('Відпрацьовано'),dataId:'worked',typeVal:'text'}
    ]

    const setFilter=(id,val,type)=>{
        let filter=[...(wndData.filter||[])]
        const idx=filter.findIndex(el=>el.dataId===id)
        if(idx!==-1){
            if(!val) filter.splice(idx,1)
            else filter[idx].value=val
        } else if(val) filter.push({dataId:id, compare:'lk', value:val, typeVal:type})
        if (!filter.length) filter=undefined
        setWndData({...wndData,filter})
    }

    const showHideFilter=()=>{
        const showAFilter=!wndData.showAFilter
        if(!showAFilter) setWndData({...wndData,filter:undefined,showAFilter})
        else setWndData({...wndData,showAFilter})
    }

    const listFromData=(currentCol,setCurrCol)=>{
        let list=[]
        if (typeof Data !== 'undefined') list=Data.map((item)=>{
            const newItem={...item}
            if (typeof currentCol !== 'undefined' && currentCol.id===item.id) setCurrCol({...newItem})
            return newItem})
        return list
    }

    const sortList=(col,sort,list)=>{
        let needUpd=false
        let currentCol=wndData.currentCol
        if (typeof list === 'undefined') {list=listFromData(currentCol,newCol=>currentCol=newCol);needUpd=true} 
        else if (typeof wndData.list === 'undefined') {list=listFromData(currentCol,newCol=>currentCol=newCol);needUpd=true} 
        else list=wndData.list.slice()

        list.sort((a,b)=>{
            let vala=toText(a[col])
            let valb=toText(b[col])
            if(col==='id'){
                vala=parseInt(vala)
                valb=parseInt(valb)
            } else {
                vala=vala.toLowerCase()
                valb=valb.toLowerCase()
            }
            if (sort==='asc') {
                if (vala < valb) {needUpd=true;return -1}
                if (vala > valb) return 1
                return 0
            } else if (sort==='desc'){
                if (vala < valb) return 1
                if (vala > valb) {needUpd=true;return -1}
                return 0
            } else return 0
        })
        const sorting={dataId:col,sort:sort}
        if (needUpd || wndData.sorting.dataId!==col || wndData.sorting.sort!==sort) 
        setWndData({...wndData,list,sorting,currentCol})
    }

    const setHidenCols=(data)=>{
        if(data){
            const new_data=data.filter(el=>el.hiden).map(el=>el.dataId)
            setSettings({IrgStopList:{cols:new_data}})
        } else {
            inputCols(cols,setHidenCols)
        }
    }

    const filter=(fltr)=>{
        let showFilter=!wndData.showFilter
        let filter=wndData.filter
        if (fltr!==undefined) filter=fltr
        setWndData({...wndData,showFilter,filter})
    }

    const newItem=(d)=>{
        if(d){
            if(Data){
                const idx=Data.findIndex(el=>el.good.id===d.id&&!el.stop)
                if(idx!==-1) {
                    setWndData({...wndData,currentCol:{...Data[idx]}})
                    return
                }
            }
            let newData={status:'add',key:'StopList',data:{good:{id:d.id,name:d.name},start:(new Date()).toISOString(),qtt:d.qtt}}
            saveData(newData,(d)=>{})
        } else addTWnd(localestr('Вибір'),'catGoods_list',dat=>inputNumber(localestr('Введіть кількість'),'','0',val=>{newItem({...dat,qtt:val})}),undefined,undefined,1)
        return
    }
    
    const editItem=(qtt)=>{
        if (wndData.currentCol) {
            if(qtt!==undefined){
                setWndData({...wndData,currentCol:{...wndData.currentCol,qtt}})
                let newData={status:'mod',key:'StopList',data:{...wndData.currentCol,qtt}}
                saveData(newData,(d)=>{})
            }else{
                inputNumber(localestr('Введіть кількість'),'',wndData.currentCol.qtt,val=>{editItem(val)})
            }

        }
        return
    }

    const editClick=()=>{
        if (typeof wndData.currentCol === 'object') {
            if(choice) {tabChoice(wndData.currentCol);tabClose()}
            else editItem()
        }
    }
            
    const removeItem=()=>{
        if (typeof wndData.currentCol === 'object') {
            if(wndData.currentCol.stop) return
            let newData={status:'rem',key:'StopList',data:{id:wndData.currentCol.id,stop:(new Date()).toISOString()}}
            saveData(newData,()=>{})
        }
    }

    const setCol=(currentCol)=>{
        setisActive(true)
        setWndData({...wndData,currentCol})
    }
        
    const cancelEdit=()=>{
        //sortList(wndData.sorting.dataId,wndData.sorting.sort,undefined)
        //setEdit(false)

        setEdit(false)
        const newData=actions.getWndData()
        if(newData.oldCol){
            newData.currentCol={...newData.oldCol}
            newData.oldCol=undefined
            newData.list=newData.list.map(el=>el.uid!==newData.currentCol.uid?el:{...newData.currentCol})
            
        } else {
            const list=newData.list.filter(el=>el.uid!==newData.currentCol.uid)
            setWndData({...wndData,list,currentCol:undefined,oldCol:undefined})
        }
    }

    const saveValue=(d)=>{
        if(d){
            const status=d.status
            if (status==='OffLine') {msg(localestr('Помилка з\'єднання'),localestr('Помилка'),[{caption:'OK',action:()=>{}}]);return}
            if (status==='error') {msg(d.msg,localestr('Помилка'),[{caption:'OK',action:()=>{}}]);return}
            setEdit(false)
        }
        else{
            let errmsg=''
            if (typeof wndData.currentCol === 'object') {
                console.log({...wndData.currentCol})
                const date=wndData.currentCol.date
                const employee=wndData.currentCol.employee

                if (date===null || date==='') errmsg=localestr("Не заповнено дату")
                //if (employee===null || employee==='') errmsg=errmsg+' '+localestr("Не заповнено працівника")
                //if (start===null || start==='') errmsg=errmsg+' '+localestr("Не заповнено початок")
                if (errmsg!=='') alert(errmsg)
                else{
                    let id=wndData.currentCol.id
                    let item={date,employee:{id:employee.id}}
                    if(id) item.id=id
                    load('action=modStopList&data='+JSON.stringify(item),(dt)=>{saveValue(dt)})
                    /*if (id===null || id==='' || id===undefined){
                        let newData={status:'add',key:type,data:item}
                        //saveData(newData,()=>{})
                        setEdit(false)
                    }  
                    else {
                        item.id=id
                        let newData={status:'mod',key:type,data:item}
                        //saveData(newData,()=>{})
                        setEdit(false)
                    } */       
                }
            }
        }
    }

    const anyKey=(key)=>{
        if(key==='Delete') removeItem()
        else if(key==='Insert') newItem()
        else if(key==='Escape') cancelEdit()
        else if(key==='shift_F4') tabClose()
        else if(key==='F2') filter()
        //else console.log(key)
    }

    useEffect(() => {
        if (typeof Data === 'undefined') getData(type)
        else if (wndData && wndData.sorting) sortList(wndData.sorting.dataId,wndData.sorting.sort,undefined)
        else sortList('date','asc',undefined)
    // eslint-disable-next-line 
    },[Data])

    let wndDataList = typeof wndData.list === 'undefined' ? [] : wndData.list
    if(hiden) wndDataList=wndDataList.filter(item=>!item.stop)
    const sorting = typeof wndData.sorting === 'undefined' ? {} : wndData.sorting
    const showFilter = wndData.showFilter ? <FilterForm filterData={filterData} filter={wndData.filter} setFilter={filter}/> : ''  //+

    const menuData=[
        {name:localestr('Налаштування таблиці'),icon:'#b953',action:setHidenCols},
        {name:localestr('Фільтр'),icon:'#b955',action:filter},
        {name:localestr('Друк списку'),icon:'#b503',action:()=>{window.print()}},
        {name:localestr('Оновити список'),icon:'#b954',action:()=>{updateData(type)}},
        //{name:localestr('Історія змін'),icon:'#hisBut',action:objHistory},
        //{name:localestr('Остаточне видалення'),icon:'#remBut',action:clrCatalog},
    ]
    if(hiden) menuData.push({name:localestr('Показати видалені'),icon:'#remBut',action:()=>setHiden(false)})
    if(!hiden) menuData.push({name:localestr('Сховати видалені'),icon:'#remBut',action:()=>setHiden(true)})
    //if(choice) menuData.splice(2,3)

    return(
        <>
        <div style={{display:'flex',flexDirection:'column',height:'calc(100% - 3px)'}}>
        <div className='toolBar no-print'>
            <div  tabIndex='0' className='toolBarItem' title={localestr('Додати')+' (Ins)'} 
            onClick={()=>newItem()}
            onKeyUp={(e)=>{if(e.key === 'Enter') newItem()}}><img src={icon+'#addBut'} alt={localestr('Додати')} /></div>
            <div  tabIndex='0' className='toolBarItem' title={localestr('Видалити')+' (Del)'}
            onClick={()=>{removeItem()}}
            onKeyUp={(e)=>{if(e.key === 'Enter') removeItem()}}><img src={icon+'#delBut'} alt={localestr('Видалити')} /></div>
            <div  tabIndex='0' className='toolBarSeparator'></div>
            <div  tabIndex='0' className='toolBarItem' title={localestr('Автофільтр')}  
            onClick={()=>{showHideFilter()}}
            onKeyUp={(e)=>{if(e.key === 'Enter') showHideFilter()}}><img src={icon+'#filtBut'} alt={localestr('Автофільтр')} /></div>
            <div style={{flexGrow:'10'}}></div>

            <div className='toolBarItem' title={localestr('Додатково')}><Menu data={menuData}>
                <img className='toolBarIcon' src={icon+'#dnBut'} alt='' />
            </Menu></div>
            
        </div>
        <UniTable haveHeader={true} colsArr={cols} data={wndDataList} currCol={{...wndData.currentCol,edit}} sorting={sorting} filter={wndData.filter} filtArr={filterData} showFilter={wndData.showAFilter} clickSort={sortList} clickHandle={(item)=>{setCol(item)}} openHandle={editClick} keyHandle={anyKey} saveHandle={saveValue} cancelHandle={cancelEdit} setFilter={setFilter} isActive={isActive2&&isActive()}/>
        </div>
        {showFilter}
        </>
    )
    
}

export default IrgStopList